module.exports = __webpack_public_path__ + "static/conversation-966420fd8c1dd4071e882223a988dc4c.png";